import { useEffect } from 'react';

export function usePollForRef(target, shouldPoll, onFoundRef) {
    useEffect(() => {
        if (!shouldPoll) {
            return;
        }

        let tries = 0;
        let timer = setTimeout(poll, 50);

        function poll() {
            if ((!target || !target.current) && ++tries < 50) {
                timer = setTimeout(poll, 50);
            }

            onFoundRef(target.current);
        }

        return () => {
            clearTimeout(timer);
        };
    }, [target, shouldPoll]);
}
